import Base from './Base.js';

class Authenticate extends Base {
    createToken(payload) {
        return this.apiClient.post({
            requestURL : 'auth',
            payload    : payload || {
                username : 'admin@admin.com',
                password : '123456'
            }
        });
    }

    resetPasswordEmail(payload) {
        return this.apiClient.post({
            requestURL : 'api/account/password/reset-request',
            payload
        });
    }

    resetPassword(payload) {
        return this.apiClient.post({
            requestURL : 'api/account/password/reset',
            payload
        });
    }
}

export default Authenticate;
